import {Box, styled} from "@mui/material";

export const LegalContent = styled(Box)({
    padding: "20px 5%",
    color: "#FFFFFF",
    background: "rgba(33,33,33,.8)"
});